// Allow-list URL sanitisation for download anchors that consume our own
// `URL.createObjectURL(...)` blob URLs.
//
// `<a href download>` accepts any URL the browser can navigate to,
// including `javascript:` / `data:` / cross-origin URLs. The
// authenticated-media download path in Timeline.tsx always produces
// same-origin `blob:` URLs; this sanitiser exists as a defence-in-depth
// final gate against anything else accidentally reaching the anchor.
//
// For user-typed clickable links inside message bodies, see
// `sanitizeLinkHref` in markdown-render.tsx — that gate accepts only
// `http:` / `https:`.

const SAFE_PROTOCOLS = new Set(["blob:"]);

/**
 * Return a same-origin blob URL for generated download anchors;
 * `null` otherwise.
 */
export function sanitizeBlobDownloadUrl(href: string): string | null {
  try {
    const url = new URL(href);
    if (!SAFE_PROTOCOLS.has(url.protocol)) return null;
    if (typeof window === "undefined") return null;
    if (url.origin !== window.location.origin) return null;
    return url.toString();
  } catch {
    return null;
  }
}

export function sanitizeUrlForBreadcrumb(href: string): string {
  try {
    const url = new URL(href);
    if (url.protocol !== "http:" && url.protocol !== "https:") return "[unparseable]";
    if (url.origin === "null") return "[unparseable]";
    return url.origin + url.pathname;
  } catch {
    return "[unparseable]";
  }
}
